<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <breadcrumb></breadcrumb>

        <div class="top-title-content">
            <span class="title">월별정산</span>
            <span class="txt">
                전체 직원의 매출/급여 를 확인하고, 직원 한 명의 자세한 매출/급여를 확인 및 금액수정을 할 수 있습니다.
            </span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :disabled="isLoading"
                    :select-data="selectFormStaffStatus.data"
                    :select-value="selectFormStaffStatus.value"
                    :selected-value="billMonthStaffStatus"
                    @update:set="(val) => (billMonthStaffStatus = val)"
                ></select-form>
                <div class="com-calendar-wrap center">
                    <button :disabled="isLoading" class="prev-day" @click="onClickBtnPrevMonth"></button>
                    <div class="ui-month-calendar">
                        <vue-monthly-picker
                            v-model="monthlyPicker"
                            :disabled="isLoading"
                            dateFormat="YYYY년 MM월"
                        ></vue-monthly-picker>
                    </div>
                    <button :disabled="isLoading" class="next-day" @click="onClickBtnNextMonth"></button>
                </div>
                <div class="right">
                    <button class="com-btn green" @click="checkAllowedClick('PA', 4, onClickBtnRegistSalaryAddPrice)">
                        추가급여 등록
                    </button>
                    <button
                        class="com-btn blue"
                        @click="checkAllowedClick('PA', 5, onClickBtnRegistSalaryDeductionPrice)"
                    >
                        공제금액 등록
                    </button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">
                        도움말
                        <div class="com-tooltip">
                            <button class="icon"></button>
                            <div class="detail big">
                                <span class="tit">테이블 항목별 설명</span>
                                <div class="division-wrap">
                                    <div class="info-area">
                                        <span class="tit">듀엣횟수</span>
                                        <p class="txt">
                                            듀엣 횟수는 참여한 인원 수와 상관없이 수업 1타임 기준 1회 입니다.
                                        </p>
                                        <span class="tit">그룹횟수</span>
                                        <p class="txt">
                                            그룹횟수는 참여한 인원 수와 상관없이 수업 1타임 기준 1회 입니다.
                                        </p>
                                        <span class="tit">소진금액</span>
                                        <p class="txt">
                                            소진금액 = 1회당 단가 x 사용횟수
                                            <br />
                                            예시 )
                                            <br />
                                            결제금액 : 10회 500,000 원
                                            <br />
                                            회당단가 : 50,000 원
                                            <br />
                                            수업 3회 사용완료인 경우,
                                            <br />
                                            소진매출 : 150,000 원
                                            <br />
                                            잔여금액 : 350,000 원
                                        </p>
                                    </div>
                                    <div class="info-area">
                                        <span class="tit">잔여금액</span>
                                        <p class="txt">
                                            해당 강사가 담당강사로 배정 된 유효회원의 구매가에서 소진금액을
                                            <br />
                                            제외하고 남은 누적잔여금액의 총 합계
                                            <br />
                                            <br />

                                            예시)
                                            <br />
                                            결제금액 : 10회 500,000 원
                                            <br />
                                            회당 단가 : 50,000 원
                                            <br />
                                            수업 3회 사용완료인 경우,
                                            <br />
                                            소진매출 : 150,000 원
                                            <br />
                                            잔여금액 : 350,000 원
                                        </p>
                                        <span class="tit">신규매출</span>
                                        <p class="txt">
                                            이번 달에 결제 된 신규 이용권 중, '매출직원' 이 해당 직원으로
                                            <br />
                                            선택된 결제금액
                                        </p>
                                        <span class="tit">신규 수</span>
                                        <p class="txt">
                                            이번 달에 결제 된 이용권 중, 회원의 '담당강사' 가 해당 직원으로
                                            <br />
                                            처음 선택된 건 수
                                        </p>
                                    </div>
                                    <div class="info-area">
                                        <span class="tit">재등록 매출</span>
                                        <p class="txt">
                                            이번 달에 결제 된 이용권 중, '매출직원' 이 해당직원으로 2번 이상
                                            <br />
                                            재등록 된 결제금액
                                        </p>
                                        <span class="tit">재등록 수</span>
                                        <p class="txt">
                                            이번 달에 결제 된 이용권 중, 회원의 '담당강사' 가 해당 직원으로 2번 이상
                                            <br />
                                            재등록된 회원 수
                                        </p>
                                        <p class="txt red">
                                            ※ 소진금액, 잔여금액은 이용권의 횟수가 정해져 있는 '총 N회'인 이용권의
                                            합계입니다. 주 N회/무제한 횟수의 이용권은 정확한 금액을 환산할 수 없으므로
                                            산출하지 않습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
            <loading-spinner v-if="isLoading" :message='loadingMessage' />
            <table v-else class="com-table salary">
                <colgroup>
                    <col style="width: 80px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                </colgroup>
                <thead>
                    <tr>
                        <th rowspan="2">직원명</th>
                        <th>개인 횟수</th>
                        <th>OT 횟수</th>
                        <th>듀엣 횟수</th>
                        <th>그룹 횟수</th>
                        <th>총 횟수</th>
                        <th>소진금액</th>
                        <th>잔여금액</th>
                        <th>신규매출</th>
                        <th>신규 수</th>
                        <th>재등록 매출</th>
                        <th>재등록 수</th>
                        <th>총 매출</th>
                    </tr>
                    <tr>
                        <th>개인 급여</th>
                        <th>OT 급여</th>
                        <th>듀엣 급여</th>
                        <th>그룹 급여</th>
                        <th>기본급</th>
                        <th>추가급여</th>
                        <th>지급합계</th>
                        <th>4대보험</th>
                        <th>세금</th>
                        <th>기타공제</th>
                        <th>공제합계</th>
                        <th>차인 지급액</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in monthBillList">
                        <tr :key="`A${index}`">
                            <td rowspan="2">{{ item.csbb_center_staff_nm }}</td>
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/salary/use?staffId=${item.csbb_center_staff_id}&selectData=P&month=${monthlyPicker}`,
                                    }"
                                    class="link"
                                >
                                    {{ (item.csbb_less_person_cnt || 0) | numberFormatFilter }}회
                                </router-link>
                            </td>
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/salary/use?staffId=${item.csbb_center_staff_id}&selectData=O&month=${monthlyPicker}`,
                                    }"
                                    class="link"
                                >
                                    {{ (item.csbb_less_ot_cnt || 0) | numberFormatFilter }}회
                                </router-link>
                            </td>
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/salary/use?staffId=${item.csbb_center_staff_id}&selectData=D&month=${monthlyPicker}`,
                                    }"
                                    class="link"
                                >
                                    {{ (item.csbb_less_duet_cnt || 0) | numberFormatFilter }}회
                                </router-link>
                            </td>
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/salary/use?staffId=${item.csbb_center_staff_id}&selectData=G&month=${monthlyPicker}`,
                                    }"
                                    class="link"
                                >
                                    {{ (item.csbb_less_group_cnt || 0) | numberFormatFilter }}회
                                </router-link>
                            </td>
                            <td>
                                <strong>{{ (item.csbb_less_total_cnt || 0) | numberFormatFilter }}회</strong>
                            </td>
                            <td>
                                <!-- 소진금액 -->
                                {{ (item.csbb_tick_use_price || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 잔여금액 -->
                                {{ (item.csbb_tick_remain_price || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 신규매출 -->
                                {{ (item.csbb_sale_new_price || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 신규 수 -->
                                {{ (item.csbb_sale_new_cnt || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 재등록 매출 -->
                                {{ (item.csbb_sale_renew_price || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 재등록 수-->
                                {{ (item.csbb_sale_renew_cnt || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <button class="pop blue" @click="onClickStaffAllSum(item.csbb_center_staff_id)">
                                    <!-- 총 매출 -->
                                    {{ (item.csbb_total_sale_price || 0) | numberFormatFilter }}
                                </button>
                            </td>
                        </tr>
                        <tr :key="`B${index}`">
                            <td>
                                <!-- 개인 급여 -->
                                {{ (item.csbb_less_person_pay || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- OT 급여 -->
                                {{ (item.csbb_less_ot_pay || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 듀엣 급여 -->
                                {{ (item.csbb_less_duet_pay || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 그룹 급여 -->
                                {{ (item.csbb_less_group_pay || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 기본급 -->
                                {{ (item.csbb_sal_base || 0) | numberFormatFilter }}
                            </td>
                            <td>
                                <!-- 추가 급여 -->
                                <button
                                    class="pop blue"
                                    @click="onClickModifySalaryAddPrice(item.csbb_center_staff_id, item)"
                                >
                                    {{ (item.csbb_sal_incen_price || 0) | numberFormatFilter }}
                                </button>
                            </td>
                            <td>
                                <span class="blue">
                                    <!-- 지급합계 -->
                                    {{ (item.csbb_sal_total_price || 0) | numberFormatFilter }}
                                </span>
                            </td>
                            <td>
                                <span class="red">
                                    <!-- 4대보험 -->
                                    {{ (item.csbb_tax_insu_price || 0) | numberFormatFilter }}
                                </span>
                            </td>
                            <td>
                                <span class="red">
                                    <!-- 세금 -->
                                    {{ (item.csbb_tax_incm_price || 0) | numberFormatFilter }}
                                </span>
                            </td>
                            <td>
                                <span class="red">
                                    <!-- 기타공제 -->
                                    {{ (item.csbb_tax_etc_price || 0) | numberFormatFilter }}
                                </span>
                            </td>
                            <td>
                                <button
                                    class="pop red"
                                    @click="onClickModifySalaryDeductionPrice(item.csbb_center_staff_id)"
                                >
                                    <!-- 공제합계 -->
                                    {{ (item.csbb_tax_total_price || 0) | numberFormatFilter }}
                                </button>
                            </td>
                            <td>
                                <strong>
                                    <!-- 차인 지급액 -->
                                    {{ (item.csbb_real_sale_price || 0) | numberFormatFilter }}
                                </strong>
                            </td>
                        </tr>
                    </template>
                    <tr v-if="monthBillList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                    <template v-else>
                        <tr
                            style="
                                border-top: solid 2px black;
                                border-left: solid 2px black;
                                border-right: solid 2px black;
                            "
                        >
                            <td rowspan="2">합계</td>
                            <td>{{ monthBillList.map((a) => a.csbb_less_person_cnt).reduce((a, b) => a + b) }}회</td>
                            <td>{{ monthBillList.map((a) => a.csbb_less_ot_cnt).reduce((a, b) => a + b) }}회</td>
                            <td>{{ monthBillList.map((a) => a.csbb_less_duet_cnt).reduce((a, b) => a + b) }}회</td>
                            <td>{{ monthBillList.map((a) => a.csbb_less_group_cnt).reduce((a, b) => a + b) }}회</td>
                            <td>{{ monthBillList.map((a) => a.csbb_less_total_cnt).reduce((a, b) => a + b) }}회</td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_tick_use_price)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_tick_remain_price)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_sale_new_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_sale_new_cnt)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_sale_renew_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_sale_renew_cnt)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_total_sale_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                        </tr>
                        <tr style="border-left: solid 2px black; border-right: solid 2px black">
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_less_person_pay)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_less_ot_pay)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_less_duet_pay)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_less_group_pay)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => a.csbb_sal_base)
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_sal_incen_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_sal_total_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_tax_insu_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_tax_incm_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_tax_etc_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_tax_total_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                            <td>
                                {{
                                    monthBillList
                                        .map((a) => parseInt(a.csbb_real_sale_price))
                                        .reduce((a, b) => a + b)
                                        .toLocaleString()
                                }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div v-if="!isLoading" class="total-count">
                <span class="count">
                    <span class="txt">급여 합계</span>
                    <span class="num">{{ (totalSalaryAmount || 0) | numberFormatFilter }}</span>
                </span>
            </div>
        </div>
        <div v-if="!isLoading" class="com-btn-area">
            <div class="left-box">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
            </div>
        </div>

        <!-- 추가급여 등록 팝업 -->
        <div v-show="salaryPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="onClickBtnCloseSalaryAddPrice">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        추가급여 등록
                        <span class="month">
                            {{ editFieldAddPrice.billYear }}년 {{ editFieldAddPrice.billMonth }}월
                        </span>
                    </span>
                    <div class="salary-add-box">
                        <div class="top-select">
                            <select-form
                                :disabled="editFieldAddPrice.isModify"
                                :select-data="selectFormInStaff.data"
                                :select-value="selectFormInStaff.value"
                                :selected-value="editFieldAddPrice.staffId"
                                class="w120"
                                @update:set="(val) => (editFieldAddPrice.staffId = val)"
                            ></select-form>
                        </div>
                        <div
                            v-if="
                                editFieldAddPrice.isModify &&
                                editFieldAddPrice.staffId !== '' &&
                                incentiveSetting.useYn !== false
                            "
                            class="sell-info"
                        >
                            <span class="txt">
                                매출 인센티브 :
                                <span class="num">{{ (totalSaleIncentive || 0) | numberFormatFilter }} 원</span>
                                ({{ incentiveSetting.name }}
                                {{ (incentiveSetting.price || 0) | numberFormatFilter }} 원,
                                {{ incentiveSetting.percent || 0 }} %)
                            </span>
                        </div>
                        <div class="info-cnt">
                            <span class="tit">추가내역</span>
                            <ul class="list">
                                <li v-for="(item, index) in editFieldAddPrice.list" :key="`C${index}`">
                                    <div class="input-line">
                                        <input
                                            v-model="item.content"
                                            class="w100p"
                                            placeholder="추가급여 내용을 입력하세요"
                                            type="text"
                                        />
                                    </div>
                                    <div class="input-line">
                                        <input
                                            v-model="item.addPrice"
                                            class="w85"
                                            type="text"
                                            @keypress="isNumber($event)"
                                            @keyup="onChangeAddPriceValue(item)"
                                        />
                                        <span class="txt">원&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X</span>
                                        <input
                                            v-model="item.addCount"
                                            class="w50 center"
                                            type="text"
                                            @keypress="isNumber($event)"
                                            @keyup="onChangeAddPriceValue(item)"
                                        />
                                        <span class="txt">회&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소계</span>
                                        <input v-model="item.addTotalPrice" class="w90" readonly type="text" />
                                        <span class="txt">원</span>
                                        <button
                                            v-if="editFieldAddPrice.list.length !== index + 1"
                                            class="com-btn red"
                                            @click="onClickBtnDeleteAddPriceItem(index)"
                                        >
                                            삭제
                                        </button>
                                        <button v-else class="com-btn" @click="onClickBtnAddPriceItem">추가</button>
                                    </div>
                                </li>
                            </ul>
                            <div class="sum-cnt">
                                <span class="txt">합계</span>
                                <input v-model="editFieldAddPrice.totalPrice" class="w200" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickBtnCloseSalaryAddPrice">취소</button>
                        <button
                            v-if="!editFieldAddPrice.isModify"
                            class="com-btn blue"
                            @click="onClickBtnRegistAddPrice"
                        >
                            등록
                        </button>
                        <button v-else class="com-btn blue" @click="onClickBtnModifyAddPrice">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 공제금액 등록 팝업 -->
        <div v-show="deductPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="onClickBtnCloseSalaryDeductionPrice">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        공제금액 등록
                        <span class="month">
                            {{ editFieldDeductionPrice.billYear }}년 {{ editFieldDeductionPrice.billMonth }}월
                        </span>
                    </span>
                    <div class="salary-add-box">
                        <div class="top-select">
                            <select-form
                                :select-data="selectFormInStaff.data"
                                :select-value="selectFormInStaff.value"
                                :selected-value="editFieldDeductionPrice.staffId"
                                class="w120"
                                @update:set="onUpdateStaffDeduction"
                            ></select-form>
                            <!-- :disabled="editFieldDeductionPrice.isModify" -->
                        </div>
                        <div class="info-cnt">
                            <span class="tit">공제내역</span>
                            <ul class="list">
                                <li class="left-title">
                                    <span class="tit">사업소득세</span>
                                    <input
                                        v-model="editFieldDeductionPrice.taxBizIncome"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                                <li class="left-title">
                                    <span class="tit">지방소득세</span>
                                    <input
                                        v-model="editFieldDeductionPrice.taxLocalIncome"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                                <li class="left-title">
                                    <span class="tit">근로소득세</span>
                                    <input
                                        v-model="editFieldDeductionPrice.taxEarnedIncome"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>

                                <li class='left-title'>
                                    <span class='tit'>종합소득세</span>
                                    <input v-model='editFieldDeductionPrice.taxWithholding' class='w200' type='text' readonly />
                                    <span class='txt'>원</span>
                                </li>

                                <li class="left-title">
                                    <span class="tit">국민연금</span>
                                    <input
                                        v-model="editFieldDeductionPrice.insuNationPrice"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                                <li class="left-title">
                                    <span class="tit">건강보험</span>
                                    <input
                                        v-model="editFieldDeductionPrice.insuHealthPrice"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                                <li class="left-title">
                                    <span class="tit">장기요양</span>
                                    <input
                                        v-model="editFieldDeductionPrice.insuLongTermPrice"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                                <li class="left-title">
                                    <span class="tit">고용보험</span>
                                    <input
                                        v-model="editFieldDeductionPrice.insuEmpPrice"
                                        class="w200"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeDeductionPrice"
                                    />
                                    <span class="txt">원</span>
                                </li>
                            </ul>
                        </div>
                        <div class="info-cnt">
                            <span class="tit">기타</span>
                            <ul class="list">
                                <li v-for="(item, index) in editFieldDeductionPrice.list" :key="index">
                                    <div class="input-line">
                                        <input v-model="item.content" class="w205" placeholder="내용입력" type="text" />
                                        <input
                                            v-model="item.addTotalPrice"
                                            class="w140"
                                            placeholder="공제액 입력"
                                            type="text"
                                            @keypress="isNumber($event)"
                                            @keyup="onChangeDeductionAddTotalPrice(item)"
                                        />
                                        <span class="txt">원</span>
                                        <button
                                            v-if="editFieldDeductionPrice.list.length !== index + 1"
                                            class="com-btn red"
                                            @click="onClickBtnDeleteDeductionAddPriceItem(index)"
                                        >
                                            삭제
                                        </button>
                                        <button v-else class="com-btn" @click="onClickBtnDeductionAddPriceItem">
                                            추가
                                        </button>
                                    </div>
                                </li>
                            </ul>
                            <div class="sum-cnt">
                                <span class="txt">합계</span>
                                <input v-model="editFieldDeductionPrice.totalPrice" class="w200" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickBtnCloseSalaryDeductionPrice">취소</button>
                        <button
                            v-if="!editFieldDeductionPrice.isModify"
                            class="com-btn blue"
                            @click="onClickBtnRegistDeductionPrice"
                        >
                            등록
                        </button>
                        <button v-else class="com-btn blue" @click="onClickBtnModifyDeductionPrice">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 총 매출 팝업 -->
        <div v-show="allSumPop" class="layer-pop square-type">
            <div class="view-content w1000">
                <button class="close" @click="onClickBtnCloseStaffAllSum"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        총 매출
                        <small>이용권 결제 시, ‘매출직원’으로 선택된 결제내역 입니다.</small>
                    </span>
                    <div class="salary-add-box">
                        <div class="top-select">
                            <select-form
                                :disabled="true"
                                :select-data="selectFormStaff.data"
                                :select-value="selectFormStaff.value"
                                :selected-value="staffAllSum.staffId"
                                class="w120"
                            ></select-form>
                        </div>
                        <div class="table-cnt">
                            <span class="top-count">
                                신규매출 :
                                <span class="num">{{ staffAllSum.newDataSum | numberFormatFilter }} 원</span>
                            </span>
                            <table class="com-table">
                                <colgroup>
                                    <col style="width: 100px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>결제일자</th>
                                        <th>
                                            <button>회원명</button>
                                        </th>
                                        <th>
                                            <button>이용권명</button>
                                        </th>
                                        <th>유효기간</th>
                                        <th>
                                            <button>결제정보</button>
                                        </th>
                                        <th>담당강사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in staffAllSum.newRegistList" :key="index">
                                        <td>{{ addtimes(item.ccb_buy_dt) }}</td>
                                        <td>{{ item.cust_namee }}</td>
                                        <td>{{ item.ccp_prod_nm }}</td>
                                        <td>
                                            {{ item.ccp_exp_start_dt | dateSplitFilter }} ~
                                            {{ item.ccp_exp_end_dt | dateSplitFilter }}
                                        </td>
                                        <td>{{ item.paymentInfos }}</td>
                                        <td>{{ item.cs_namee }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-cnt">
                            <span class="top-count">
                                재등록매출 :
                                <span class="num">{{ staffAllSum.reDataSum | numberFormatFilter }} 원</span>
                            </span>
                            <table class="com-table">
                                <colgroup>
                                    <col style="width: 100px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                    <col style="width: 90px" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>결제일자</th>
                                        <th>
                                            <button>회원명</button>
                                        </th>
                                        <th>
                                            <button>이용권명</button>
                                        </th>
                                        <th>유효기간</th>
                                        <th>
                                            <button>결제정보</button>
                                        </th>
                                        <th>담당강사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in staffAllSum.reRegistList" :key="index">
                                        <td>{{ item.cc_buy_dt | dateSplitFilter }}</td>
                                        <td>{{ item.cust_namee }}</td>
                                        <td>{{ item.ccp_prod_nm }}</td>
                                        <td>
                                            {{ item.ccp_exp_start_dt | dateSplitFilter }} ~
                                            {{ item.ccp_exp_end_dt | dateSplitFilter }}
                                        </td>
                                        <td>{{ item.paymentInfos }}</td>
                                        <td>{{ item.cs_namee }}</td>
                                    </tr>
                                    <!--
                                <tr>
                                    <td>2020-01-26</td>
                                    <td>강민희</td>
                                    <td>[개인] 필라테스 20회 (60분)</td>
                                    <td>2019-08-02 ~ 2019-12-02</td>
                                    <td>[카드] 1,000,000 원</td>
                                    <td>김윤경</td>
                                </tr>
                                --></tbody>
                            </table>
                        </div>
                        <div class="sum-count">
                            <span class="txt">
                                총 매출 :
                                <span class="num">
                                    {{ (staffAllSum.newDataSum + staffAllSum.reDataSum) | numberFormatFilter }} 원
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickBtnCloseStaffAllSum">취소</button>
                        <button class="com-btn blue">등록</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import LoadingSpinner from '@/components/LoadingSpinner';
import XLSX from 'xlsx';

export default {
    name: 'SalaryMonth',
    components: { LoadingSpinner },
    mixins: [MixinAllowedMenu],
    props: {},
    watch: {
        billMonthStaffStatus() {
            this.fetchCenterSalaryStaffMonthBill();
        },
        monthlyPicker() {
            this.fetchCenterSalaryStaffMonthBill();
        },
    },
    computed: {
        selectedMonth() {
            return this.monthlyPicker.format('YYYY-MM');
        },
        totalSaleIncentive() {
            const totalSaleIncetive = (this.incentiveSetting.price * this.incentiveSetting.percent) / 100;
            if (this.incentiveSetting.incentiveVatYn) {
                return Math.floor((totalSaleIncetive * 10) / 11);
            }
            return Math.floor(totalSaleIncetive);
        },
    },
    data() {
        return {
            isLoading: false,
            loadingMessage: '',
            centerId: '',
            staffList: {},
            monthBillList: [],
            totalSalaryAmount: 0,
            selectFormStaffStatus: {
                data: ['근무중인 직원', '퇴사한 직원', '전체'],
                value: ['I', 'O', ''],
            },
            billMonthStaffStatus: 'I',
            selectFormStaff: {
                data: [],
                value: [],
                selectedValue: '',
            },
            // 재직 중인 직원
            selectFormInStaff: {
                data: [],
                value: [],
                selectedValue: '',
            },
            monthlyPicker: moment(), // 년월 설정
            salaryPop: false, // 추가급여 등록 팝업
            deductPop: false, // 공제금액 등록 팝업
            allSumPop: false, // 총매출 팝업
            editFieldAddPrice: {},
            editFieldDeductionPrice: {
                isModify: false,
            },
            staffAllSum: {
                newRegistList: [],
                reRegistList: [],
                newDataSum: 0,
                reDataSum: 0,
                staffId: '',
            },
            addPriceTemplate: {
                // addPrice 객체 탬플릿
                addPrice: 0,
                addCount: 1,
                addTotalPrice: 0,
                content: '',
            },
            deductionFields: [
                'taxBizIncome',
                'taxLocalIncome',
                'taxEarnedIncome',
                'taxWithholding',
                'insuNationPrice',
                'insuHealthPrice',
                'insuLongTermPrice',
                'insuEmpPrice',
            ],
            incentiveSetting: '',
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.centerId = this.$store.getters['auth/cId'];
            Promise.allSettled([this.fetchCenterStaffAllList(), this.fetchCenterSalaryStaffMonthBill()]);
        },
        addtimes(time) {
            return moment(time).add(9, 'hours').format('YYYY-MM-DD');
        },
        // 엑셀 다운로드
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const excelDownloadArray = [];

            for (const item of this.monthBillList) {
                const temp = {};
                temp['직원명'] = item.csbb_center_staff_nm;
                temp['개인 횟수'] = item.csbb_less_person_cnt;
                temp['개인 급여'] = item.csbb_less_person_pay;
                temp['OT 횟수'] = item.csbb_less_ot_cnt;
                temp['OT 급여'] = item.csbb_less_ot_pay;
                temp['듀엣 횟수'] = item.csbb_less_duet_cnt;
                temp['듀엣 급여'] = item.csbb_less_duet_pay;
                temp['그룹 횟수'] = item.csbb_less_group_cnt;
                temp['그룹 급여'] = item.csbb_less_group_pay;
                temp['총 횟수'] = item.csbb_less_total_cnt;
                temp['기본급'] = item.csbb_sal_base;
                temp['추가 급여'] = item.csbb_sal_incen_price;
                temp['지급합계'] = item.csbb_sal_total_price;
                temp['4대 보험'] = item.csbb_tax_insu_price;
                temp['세금'] = item.csbb_tax_incm_price;
                temp['기타 공제'] = item.csbb_tax_etc_price;
                temp['공제 합계'] = item.csbb_tax_total_price;
                temp['차인 지급액'] = item.csbb_real_sale_price;
                temp['소진금액'] = item.csbb_tick_use_price;
                temp['잔여금액'] = item.csbb_tick_remain_price;
                temp['신규매출'] = item.csbb_sale_new_price;
                temp['신규 수'] = item.csbb_sale_new_cnt;
                temp['재등록 매출'] = item.csbb_sale_renew_price;
                temp['재등록 수'] = item.csbb_sale_renew_cnt;
                temp['총 매출'] = item.csbb_total_sale_price;

                excelDownloadArray.push(temp);
            }

            const sumReducer = (prev, current) => prev + current;

            const temp = {};
            temp['직원명'] = '';
            temp['개인 횟수'] = '';
            temp['개인 급여'] = '';
            temp['OT 횟수'] = '';
            temp['OT 급여'] = '';
            temp['듀엣 횟수'] = '';
            temp['듀엣 급여'] = '';
            temp['그룹 횟수'] = '';
            temp['그룹 급여'] = '';
            temp['총 횟수'] = '';
            temp['기본급'] = '';
            temp['추가 급여'] = '';
            temp['지급합계'] = '';
            temp['4대 보험'] = '';
            temp['세금'] = '';
            temp['기타 공제'] = '';
            temp['공제 합계'] = '급여 합계';
            temp['차인 지급액'] = this.monthBillList
                .map((item) => parseInt(item.csbb_real_sale_price, 10))
                .reduce(sumReducer);
            temp['소진금액'] = '';
            temp['잔여금액'] = '';
            temp['신규매출'] = '';
            temp['신규 수'] = '';
            temp['재등록 매출'] = '';
            temp['재등록 수'] = '';
            temp['총 매출'] = '';

            excelDownloadArray.push(temp);

            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, '월별정산');
            XLSX.writeFile(wb, '매출현황_상품.xlsx');
        },
        async fetchCenterSalaryStaffMonthBill() {
            try {
                this.isLoading = true;
                this.loadingMessage = '급여정산 중입니다.\n잠시만 기다려 주세요.';

                const { centerId, billMonthStaffStatus: status } = this;
                const [billYear, billMonth] = this.selectedMonth.split('-');

                const params = {
                    centerId,
                    billYear,
                    billMonth,
                    status,
                };

                // 권한에 따른 처리
                const centerStaffId = this.$store.getters['auth/staffId'];
                if (!this.isAllowed('PA', 3)) {
                    if (this.isAllowed('PA', 2)) {
                        // 본인 + 같은 팀
                        const { data: sameTeamStaffs } = await this.getCenterSameTeamStaffList();
                        params.staffIdList =
                            sameTeamStaffs.length > 0
                                ? sameTeamStaffs.map((v) => v.center_staff_id).join(',')
                                : centerStaffId;
                    } else if (this.isAllowed('PA', 1)) {
                        // 본인만
                        params.staffIdList = centerStaffId;
                    }
                }

                const { data } = await this.getCenterSalaryStaffMonthBill(params);
                this.monthBillList = data;

                this.totalSalaryAmount = 0;
                for (const d of data) {
                    this.totalSalaryAmount += parseInt(d.csbb_sal_total_price - d.csbb_tax_total_price); // 급여 합계
                }
                this.isLoading = false;
            } catch (e) {
                console.log(e);
                this.isLoading = false;
            }
        },
        async fetchCenterStaffAllList() {
            try {
                const { data } = await this.getCenterStaffAllList();
                const selectFormObj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data, '선택');

                this.selectFormStaff.data = selectFormObj.data;
                this.selectFormStaff.value = selectFormObj.value;

                const inStaff = data.filter((staff) => staff.status === 'I');
                this.selectFormInStaff.data = ['선택', ...inStaff.map((staff) => staff.name)];
                this.selectFormInStaff.value = ['', ...inStaff.map((staff) => staff.centerStaffId)];
            } catch (e) {
                console.log(e);
            }
        },
        async getCenterSalaryStaffMonthBill(params) {
            // 스웨거 검색: 월별정산 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/salary/staff/month-bill`, {
                params,
            });
        },
        getCenterSameTeamStaffList() {
            const centerStaffId = this.$store.getters['auth/staffId'];
            return api.get(`/admin/api/center/${this.centerId}/staff/${centerStaffId}/sameTeamStaffs`);
        },
        getCenterStaffAllList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/all/list`);
        },
        getCenterStaffMonthBillAddPrice(billYear, billMonth, staffId) {
            const params = {
                billYear,
                billMonth,
                salaryYn: true,
            };
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/add-price`;
            return api.get(url, { params });
        },
        getCenterStaffMonthBillDeductionPrice(billYear, billMonth, staffId) {
            const params = {
                billYear,
                billMonth,
            };
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/deduction-price`;
            return api.get(url, { params });
        },
        getCenterStaffMonthBillTaxWithholding(billYear, billMonth, staffId) {
            const params = {
                billYear,
                billMonth,
            };
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/tax-withholding`;
            return api.get(url, { params });
        },
        getCenterStaffAllSumNewRegister(staffId) {
            return this.getCenterStaffAllSum(staffId, 'N');
        },
        getCenterStaffAllSumReregister(staffId) {
            return this.getCenterStaffAllSum(staffId, 'R');
        },
        getCenterStaffAllSum(staffId, lessStaffContractType) {
            // 직원 총매출 조회
            const [billYear, billMonth] = this.selectedMonth.split('-');
            const params = {
                lessStaffContractType,
                billYear,
                billMonth,
            };

            // 스웨거 검색: 직원 총매출 목록 조회
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/total-sales`;
            return api.get(url, { params });
        },
        async onClickBtnRegistAddPrice() {
            const { editFieldAddPrice } = this;

            if (editFieldAddPrice.staffId === '') {
                alert('직원을 선택해주세요.');
                return false;
            }

            const params = this.getEditAddPriceParams();

            if (!params || !confirm('등록하시겠습니까?')) {
                return false;
            }

            try {
                await this.postStaffAddPrice({ details: params }, editFieldAddPrice.staffId);
                this.closeSalaryPop();

                this.fetchCenterSalaryStaffMonthBill();
            } catch (e) {
                alert('오류가 발생하였습니다.');
                console.log(e);
            }
        },
        async onClickBtnModifyAddPrice() {
            const { editFieldAddPrice } = this;
            if (editFieldAddPrice.staffId === '') {
                alert('직원을 선택해주세요.');
                return false;
            }

            const params = this.getEditAddPriceParams();

            if (!params || !confirm('수정하시겠습니까?')) {
                return false;
            }

            try {
                await this.postStaffAddPrice({ details: params }, editFieldAddPrice.staffId);
                for (const item of editFieldAddPrice.deletedList) {
                    // API가 중복 삭제를 지원하지 않아 여러번 전송으로 처리
                    await this.deleteStaffAddPrice(item.centerStaffAddPriceId, editFieldAddPrice.staffId);
                }
                this.closeSalaryPop();

                this.fetchCenterSalaryStaffMonthBill();
            } catch (e) {
                alert('오류가 발생하였습니다.');
                console.log(e);
            }
        },
        async onClickBtnRegistDeductionPrice() {
            const { editFieldDeductionPrice } = this;
            if (editFieldDeductionPrice.staffId === '') {
                alert('직원을 선택해주세요.');
                return false;
            }

            const params = this.getEditDeductionPriceParams();

            if (!params || !confirm('등록하시겠습니까?')) {
                // if(!confirm("등록하시겠습니까?")) {
                return false;
            }

            try {
                await this.postStaffDeductionAddPrice(params, editFieldDeductionPrice.staffId);

                this.initEditFieldDeductionPrice();
                this.closeDeductPop();

                await this.fetchCenterSalaryStaffMonthBill();
            } catch (e) {
                alert('오류가 발생하였습니다.');
                console.log(e);
            }
        },
        async onClickBtnModifyDeductionPrice() {
            const { editFieldDeductionPrice } = this;
            if (editFieldDeductionPrice.staffId === '') {
                alert('직원을 선택해주세요.');
                return false;
            }

            const params = this.getEditDeductionPriceParams();

            if (!params || !confirm('수정하시겠습니까?')) {
                return false;
            }

            try {
                await this.putStaffDeductionAddPrice(params, editFieldDeductionPrice.staffId);
                for (const item of editFieldDeductionPrice.deletedList) {
                    // API가 중복 삭제를 지원하지 않아 여러번 전송으로 처리
                    await this.deleteStaffAddPrice(item.centerStaffAddPriceId, editFieldDeductionPrice.staffId);
                }

                this.initEditFieldDeductionPrice();
                this.closeDeductPop();
                await this.fetchCenterSalaryStaffMonthBill();
            } catch (e) {
                alert('오류가 발생하였습니다.');
                console.log(e);
            }
        },
        postStaffAddPrice(params, staffId) {
            return api.post(`/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/add-price`, params);
        },
        deleteStaffAddPrice(centerStaffAddPriceId, staffId) {
            if (centerStaffAddPriceId === undefined || centerStaffAddPriceId === null) {
                return false;
            }
            return api.delete(
                `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/add-price/${centerStaffAddPriceId}`
            );
        },
        postStaffDeductionAddPrice(params, staffId) {
            // 스웨거 검색: 공제금액 등록
            return api.post(
                `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/deduction-price`,
                params
            );
        },
        async putStaffDeductionAddPrice(params, staffId) {
            return api.put(
                `/admin/api/center/${this.centerId}/salary/staff/${staffId}/month-bill/deduction-price`,
                params
            );
        },
        onChangeAddPriceValue(item) {
            item.addCount = Utils.getPureNumber(item.addCount);
            item.addPrice = Utils.getPureNumber(item.addPrice);

            item.addTotalPrice = item.addPrice * item.addCount;

            item.addPrice = Utils.getNumberFormat(item.addPrice);
            item.addCount = Utils.getNumberFormat(item.addCount);
            item.addTotalPrice = Utils.getNumberFormat(item.addTotalPrice);

            this.sumEditFieldAddPrice();
        },
        onChangeDeductionPrice() {
            const { editFieldDeductionPrice } = this;

            // Number Format 일괄 처리
            const sum = 0;
            for (const fn of this.deductionFields) {
                const num = Utils.getPureNumber(editFieldDeductionPrice[fn]);
                editFieldDeductionPrice[fn] = Utils.getNumberFormat(num);
            }

            this.sumEditFieldDeductionPrice();
        },
        onChangeDeductionAddTotalPrice(item) {
            item.addTotalPrice = Utils.getPureNumber(item.addTotalPrice);
            item.addTotalPrice = Utils.getNumberFormat(item.addTotalPrice);

            this.sumEditFieldDeductionPrice();
        },
        onClickBtnAddPriceItem() {
            this.editFieldAddPrice.list.push({ ...this.addPriceTemplate });
        },
        onClickBtnDeleteAddPriceItem(index) {
            const deletedItem = { ...this.editFieldAddPrice.list[index] };
            if ('centerStaffAddPriceId' in deletedItem) {
                // 수정하는 데이터라면 삭제할 목록으로 이동
                this.editFieldAddPrice.deletedList.push(deletedItem);
            }

            // 현재 목록 배열에서 제거
            this.editFieldAddPrice.list.splice(index, 1);

            // 합계 재계산
            this.sumEditFieldAddPrice();
        },
        onClickBtnDeductionAddPriceItem() {
            this.editFieldDeductionPrice.list.push({ ...this.addPriceTemplate });
        },
        onClickBtnDeleteDeductionAddPriceItem(index) {
            const deletedItem = { ...this.editFieldDeductionPrice.list[index] };
            if ('centerStaffAddPriceId' in deletedItem) {
                // 수정하는 데이터라면 삭제할 목록으로 이동
                this.editFieldDeductionPrice.deletedList.push(deletedItem);
            }

            this.editFieldDeductionPrice.list.splice(index, 1);

            // 합계 재계산
            this.sumEditFieldDeductionPrice();
        },
        onClickBtnNextMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).add(1, 'months');
        },
        onClickBtnPrevMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).subtract(1, 'months');
        },
        onClickBtnRegistSalaryAddPrice() {
            this.initEditFieldAddPrice();
            this.editFieldAddPrice.list.push({ ...this.addPriceTemplate });

            this.openSalaryPop();
        },
        onClickBtnRegistSalaryDeductionPrice() {
            this.initEditFieldDeductionPrice();
            this.editFieldDeductionPrice.list.push({ ...this.addPriceTemplate });

            this.openDeductPop();
        },
        async onClickModifySalaryAddPrice(staffId, item) {
            try {
                //권한 체크 add 24.8.13
                if (!this.checkAllowed('PA', 4)) {
                    alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                    return;
                }

                // 수정할 데이터 가져오기
                this.initEditFieldAddPrice(staffId);
                const [billYear, billMonth] = this.selectedMonth.split('-');
                const { data } = await this.getCenterStaffMonthBillAddPrice(billYear, billMonth, staffId);
                console.log(item);

                for (const d of data) {
                    const item = { ...d };

                    item.addPrice = Utils.getNumberFormat(item.addPrice);
                    item.addCount = Utils.getNumberFormat(item.addCount);
                    item.addTotalPrice = Utils.getNumberFormat(item.addTotalPrice);

                    this.editFieldAddPrice.list.push(item);
                }
                this.editFieldAddPrice.list.push({ ...this.addPriceTemplate });

                this.sumEditFieldAddPrice();
                this.staffPaySetting(staffId, item);
                this.openSalaryPop();
            } catch (e) {
                console.log(e);
            }
        },
        async onClickModifySalaryDeductionPrice(staffId) {
            try {
                //권한 체크 add 24.8.13
                if (!this.checkAllowed('PA', 4)) {
                    alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                    return;
                }
                // 수정할 데이터 가져오기
                this.initEditFieldDeductionPrice(staffId);
                await this.getAndSetStaffMonthBillDeduction(staffId);
                this.openDeductPop();
            } catch (e) {
                console.log(e);
            }
        },
        async onClickStaffAllSum(staffId) {
            try {
                this.initStaffAllSum(staffId);

                // 신규 매출
                const { data: newData } = await this.getCenterStaffAllSumNewRegister(staffId);
                this.staffAllSum.newRegistList = this.getRegistList(newData);
                this.staffAllSum.newDataSum = this.sumStaffAllSumList(newData);

                // 재등록 매출
                const { data: reData } = await this.getCenterStaffAllSumReregister(staffId);
                this.staffAllSum.reRegistList = this.getRegistList(reData);
                this.staffAllSum.reDataSum = this.sumStaffAllSumList(reData);
            } catch (e) {
                console.log(e);
            }

            this.openAllSumPop();
        },
        onClickBtnCloseSalaryAddPrice() {
            this.closeSalaryPop();
        },
        onClickBtnCloseSalaryDeductionPrice() {
            this.closeDeductPop();
        },
        onClickBtnCloseStaffAllSum() {
            this.closeAllSumPop();
        },
        openSalaryPop() {
            this.salaryPop = true;
        },
        closeSalaryPop() {
            this.editFieldAddPrice = {};
            this.salaryPop = false;
        },
        openDeductPop() {
            this.deductPop = true;
        },
        closeDeductPop() {
            this.deductPop = false;
        },
        openAllSumPop() {
            this.allSumPop = true;
        },
        closeAllSumPop() {
            this.allSumPop = false;
        },
        initEditFieldAddPrice(staffId = '') {
            const [billYear, billMonth] = this.selectedMonth.split('-');
            const isModify = staffId !== '';

            this.editFieldAddPrice = {
                staffId,
                billYear,
                billMonth,
                list: [],
                deletedList: [],
                totalPrice: 0,
                salaryYn: true, // 추가/공제 여부
                isModify,
            };
        },
        initEditFieldDeductionPrice(staffId = '') {
            const [billYear, billMonth] = this.selectedMonth.split('-');
            const isModify = staffId !== '';

            this.editFieldDeductionPrice = {
                staffId,
                billYear,
                billMonth,
                taxBizIncome: 0,
                taxLocalIncome: 0,
                taxEarnedIncome: 0,
                taxWithholding: 0,
                insuNationPrice: 0,
                insuHealthPrice: 0,
                insuLongTermPrice: 0,
                insuEmpPrice: 0,
                list: [],
                deletedList: [],
                totalPrice: 0,
                isModify,
            };
        },
        initStaffAllSum(staffId = '') {
            this.staffAllSum = {
                newRegistList: [],
                reRegistList: [],
                newDataSum: 0,
                reDataSum: 0,
                staffId,
            };
        },
        sumEditFieldDeductionFields() {
            let sum = 0;
            for (const fn of this.deductionFields) {
                sum += Utils.getPureNumber(this.editFieldDeductionPrice[fn]);
            }
            return sum;
        },
        sumEditFieldDeductionAddPrice() {
            let sum = 0;
            for (const item of this.editFieldDeductionPrice.list) {
                sum += Utils.getPureNumber(item.addTotalPrice);
            }
            return sum;
        },
        sumEditFieldDeductionPrice() {
            let sum = this.sumEditFieldDeductionFields();
            sum += this.sumEditFieldDeductionAddPrice();

            this.editFieldDeductionPrice.totalPrice = Utils.getNumberFormat(sum);
        },
        sumEditFieldAddPrice() {
            let sum = 0;
            for (const item of this.editFieldAddPrice.list) {
                sum += parseInt(Utils.getPureNumber(item.addTotalPrice));
            }
            this.editFieldAddPrice.totalPrice = Utils.getNumberFormat(sum);
        },
        getEditAddPriceParams() {
            const { editFieldAddPrice } = this;
            const { getPureNumber } = Utils;
            const { billYear, billMonth } = editFieldAddPrice;

            let params = [],
                idx = 0,
                lastIdx = editFieldAddPrice.list.length - 1;
            for (const item of editFieldAddPrice.list) {
                let param = { ...item };

                if (!('centerStaffAddPriceId' in item)) {
                    param = {
                        billYear,
                        billMonth,
                        salaryYn: true,
                        ...param,
                    };
                }

                param.addPrice = getPureNumber(param.addPrice);
                param.addCount = getPureNumber(param.addCount);
                param.addTotalPrice = getPureNumber(param.addTotalPrice);
                param.content = param.content.trim();

                // 파라미터 검증
                if (param.addTotalPrice === 0 || param.content === '') {
                    if (idx < lastIdx) {
                        // 마지막 행은 빈 값을 허용
                        alert('급여금액/내용을 입력해주세요');
                        return false;
                    }
                } else {
                    // 빈값이 아닌 데이터만 입력
                    params.push(param);
                }

                idx++;
            }

            return params;
        },
        getEditDeductionPriceParams() {
            const { editFieldDeductionPrice } = this;
            const { billYear, billMonth } = editFieldDeductionPrice;

            let centerStaffAddPrices = [],
                idx = 0,
                lastIdx = editFieldDeductionPrice.list.length - 1;
            for (const item of editFieldDeductionPrice.list) {
                let param = { ...item };

                if (!('centerStaffAddPriceId' in item)) {
                    param = {
                        billYear: parseInt(billYear),
                        billMonth: parseInt(billMonth),
                        salaryYn: false,
                        ...param,
                    };
                } else {
                    delete param.centerId;
                    delete param.centerStaffId;
                    delete param.info;
                }

                param.addPrice = 0; // getPureNumber( param.addPrice );
                param.addCount = 0; // getPureNumber( param.addCount );
                param.addTotalPrice = Utils.getPureNumber(param.addTotalPrice);
                param.content = param.content.trim();

                // 파라미터 검증
                if (param.addTotalPrice === 0 || param.content === '') {
                    if (idx < lastIdx) {
                        // 마지막 행은 빈 값을 허용
                        alert('급여금액/내용을 입력해주세요');
                        return false;
                    }
                } else {
                    // 빈값이 아닌 데이터만 입력
                    centerStaffAddPrices.push(param);
                }

                idx++;
            }

            const params = {
                billYear: parseInt(billYear),
                billMonth: parseInt(billMonth),
                taxBizIncome: Utils.getPureNumber(editFieldDeductionPrice.taxBizIncome),
                taxLocalIncome: Utils.getPureNumber(editFieldDeductionPrice.taxLocalIncome),
                taxEarnedIncome: Utils.getPureNumber(editFieldDeductionPrice.taxEarnedIncome),
                taxWithholding: Utils.getPureNumber(editFieldDeductionPrice.taxWithholding),
                insuNationPrice: Utils.getPureNumber(editFieldDeductionPrice.insuNationPrice),
                insuHealthPrice: Utils.getPureNumber(editFieldDeductionPrice.insuHealthPrice),
                insuLongTermPrice: Utils.getPureNumber(editFieldDeductionPrice.insuLongTermPrice),
                insuEmpPrice: Utils.getPureNumber(editFieldDeductionPrice.insuEmpPrice),
                centerStaffAddPrices,
            };

            return params;
        },
        sumStaffAllSumList(list) {
            let sum = 0;

            for (const item of list) {
                sum += item.ccb_bill_price;
            }

            return sum;
        },
        calculateTaxWithholding(price) {
            const deductionRate = 0.033; // 3.3% 공제율
            const deduction = price * deductionRate; // 공제 금액 계산
            return Math.floor(deduction); // 소수점을 버리고 원 단위로 절삭
        },

        async getAndSetStaffMonthBillDeduction(staffId) {
            try {
                // 수정할 데이터 가져오기
                const [billYear, billMonth] = this.selectedMonth.split('-');
                const { data } = await this.getCenterStaffMonthBillDeductionPrice(billYear, billMonth, staffId);
                const { data: taxWithholdingData  } = await this.getCenterStaffMonthBillTaxWithholding(billYear, billMonth, staffId);

                const { editFieldDeductionPrice } = this;
                let taxWithholding = 0;
                if (taxWithholdingData.taxWithholdingAppliedYn === true) {
                    const staffData = this.monthBillList.find(item => item.csbb_center_staff_id === staffId);
                    const csbb_sal_total_price = staffData ? staffData.csbb_sal_total_price : 0;
                    taxWithholding = this.calculateTaxWithholding(csbb_sal_total_price);
                }

                console.log(data);
                if (!Utils.isEmpty(data)) {
                    console.log('수정');
                    // 데이터가 존재함
                    editFieldDeductionPrice.taxBizIncome = Utils.getNumberFormat(data.taxBizIncome);
                    editFieldDeductionPrice.taxLocalIncome = Utils.getNumberFormat(data.taxLocalIncome);
                    editFieldDeductionPrice.taxEarnedIncome = Utils.getNumberFormat(data.taxEarnedIncome);
                    editFieldDeductionPrice.taxWithholding = Utils.getNumberFormat(taxWithholding);
                    editFieldDeductionPrice.insuNationPrice = Utils.getNumberFormat(data.insuNationPrice);
                    editFieldDeductionPrice.insuHealthPrice = Utils.getNumberFormat(data.insuHealthPrice);
                    editFieldDeductionPrice.insuLongTermPrice = Utils.getNumberFormat(data.insuLongTermPrice);
                    editFieldDeductionPrice.insuEmpPrice = Utils.getNumberFormat(data.insuEmpPrice);

                    if (!Utils.isEmpty(data.centerStaffAddPrices)) {
                        for (const d of data.centerStaffAddPrices) {
                            const item = { ...d };

                            item.addPrice = Utils.getNumberFormat(item.addPrice);
                            item.addCount = Utils.getNumberFormat(item.addCount);
                            item.addTotalPrice = Utils.getNumberFormat(item.addTotalPrice);

                            editFieldDeductionPrice.list.push(item);
                        }
                    }
                    editFieldDeductionPrice.list.push({ ...this.addPriceTemplate });
                    this.sumEditFieldDeductionPrice();
                    editFieldDeductionPrice.isModify = true;
                } else {
                    console.log('등록');
                    // 데이터가 존재하지 않음
                    editFieldDeductionPrice.taxWithholding = Utils.getNumberFormat(taxWithholding);

                    editFieldDeductionPrice.isModify = false;
                    editFieldDeductionPrice.list.push({ ...this.addPriceTemplate });
                }
            } catch (e) {
                console.log(e);
            }
        },
        onUpdateStaffDeduction(staffId) {
            this.initEditFieldDeductionPrice(staffId);
            if (!Utils.isEmpty(staffId)) {
                this.editFieldDeductionPrice.staffId = staffId;
                this.getAndSetStaffMonthBillDeduction(staffId);
            }
        },
        isNumber(evt) {
            return Utils.isNumber(evt);
        },
        // 직원 급여 설정
        staffPaySetting(staffId, item) {
            api.get(`/admin/api/center/${this.centerId}/staff/${staffId}/pay/setting/detail`, {
                params: {
                    applyDate: moment(this.monthlyPicker).format('YYYY-MM-01'),
                },
            }).then((res) => {
                // 초기화 해주기
                this.incentiveSetting = '';
                console.log('staff', res.data);

                if (res.data.incentiveYn == false) {
                    this.incentiveSetting = {
                        name: '',
                        percent: 0,
                        price: 0,
                        useYn: res.data.incentiveYn,
                    };
                }

                console.log('res.data.incentiveNewSale', res.data);

                if (res.data.incentiveNewSale !== null && res.data.incentiveNewSale !== undefined) {
                    this.incentiveSetting = {
                        name: '신규매출',
                        percent: res.data.incentiveNewSale,
                        price: item.csbb_sale_new_price,
                        useYn: res.data.incentiveYn,
                        incentiveVatYn: res.data.incentiveVatYn,
                    };
                } else if (res.data.incentiveRenewSale !== null && res.data.incentiveRenewSale !== undefined) {
                    this.incentiveSetting = {
                        name: '재등록매출',
                        percent: res.data.incentiveRenewSale,
                        price: item.csbb_sale_renew_price,
                        useYn: res.data.incentiveYn,
                        incentiveVatYn: res.data.incentiveVatYn,
                    };
                } else if (res.data.incentiveTotalSale !== null && res.data.incentiveTotalSale !== undefined) {
                    this.incentiveSetting = {
                        name: '총매출',
                        percent: res.data.incentiveTotalSale,
                        price: item.csbb_total_sale_price,
                        uesYn: res.data.incentiveYn,
                        incentiveVatYn: res.data.incentiveVatYn,
                    };
                }
                console.log('결과값', this.incentiveSetting);
            });
        },
        getPaymentInfo(item) {
            return `[${Utils.getPaymentTypeName(item.ccb_pay_type_cd)}] ${Utils.getNumberFormat(
                item.ccb_bill_price
            )}원`;
        },
        getRegistList(list) {
            const registList = [];

            for (const item of list) {
                const saleInfo = registList.find(
                    (newSale) => newSale.cc_center_contract_id === item.cc_center_contract_id
                );
                if (saleInfo) {
                    saleInfo.paymentInfos += `\n${this.getPaymentInfo(item)}`;
                } else {
                    item.paymentInfos = this.getPaymentInfo(item);
                    registList.push(item);
                }
            }

            return registList;
        },
    },
};
</script>
<style lang="scss"></style>
